var BufferPromptHandler = require('bufferprompthandler');


var ConnectionPromptHandler = BufferPromptHandler.extend({
    bindMessageHandlers: function () {
        for (var type in this.messageHandlers) {
            this.connection.bind('message:' + type, this.handleMessage, this);
        }
        this.connection.bind('nickPrompt', this.nickPrompt, this);
        this.connection.bind('joinPrompt', this.joinPrompt, this);
        this.connection.bind('ignorePrompt', this.ignorePrompt, this);
        this.connection.bind('invitePrompt', this.invitePrompt, this);
        this.connection.bind('genericConfirm', this.genericConfirm, this);
        this.connection.bind('deleteConfirm', this.deleteConfirm, this);
        this.connection.bind('deletePMConfirm', this.deletePMConfirm, this);
        this.connection.bind('postError', this.postError, this);
        this.model.bind('postError', this.postError, this);
        this.model.bind('sayError', this.postError, this);
        this.model.bind('longMessageConfirm', this.longMessageConfirm, this);
    },
    handleMessage: function () {
        var ret = BufferPromptHandler.prototype.handleMessage.apply(this, arguments);
        if (ret) {
            // Clear focus on make buffer if we get any prompts
            // many of them are about invalid channel names
            // that mean a join will never come
            this.connection.setFocusOnMakeBuffer(null);
        }
        return ret;
    },
    nickPromptText: function (promptText, nickLen) {
        promptText = promptText || 'Choose a new nickname';
        if (nickLen || nickLen === 0) {
            var s = Math.abs(nickLen) === 1 ? '' : 's';
            promptText += ' (' + nickLen + ' char' + s + ')';
        }
        return promptText;
    },
    standardReply: function (type, message) {
        var msg = '<b>' + type + ': ' + this.formatter.escapeText(message.command) + '</b>: ' +
            this.formatter.escapeText(message.code) + ': ' +
            this.formatter.escapeText(message.description);
        if (message.context && message.context.length) {
            msg += ' [ ' + this.formatter.escapeText(message.context.join(' , ')) + ' ]';
        }
        return this.htmlAlert(msg);
    },
    channelAlert: function (message, options) {
        options = options || {};
        var prefix = options.prefix || '';
        var msg = prefix + this.formatter.renderLinkify(options.msg || message.msg);
        var chan = options.key ? message[options.key] : message.channel || message.chan;
        if (chan) {
            msg = this.formatter.linkChannel(chan) + ': ' + msg;
        }
        return this.htmlAlert(msg);
    },
    nickPrompt: function (promptText, promptNick) {
        var nickLen = this.connection.getISupport('NICKLEN');
        promptNick = promptNick || this.connection.getNick();
        var finalPromptText = this.nickPromptText(promptText, nickLen - promptNick.length);
        var overlay = this.htmlPrompt(finalPromptText, _.bind(function (nick) {
            this.connection.nick(nick);
        }, this), promptNick, {
            onPromptKey: _.bind(function (e, input, textContainer) {
                textContainer.text(this.nickPromptText(promptText, nickLen - input.val().length));
            }, this)
        });
        overlay.className = 'connection_nick_prompt';
        this.triggerAdd(overlay);
    },
    joinPrompt: function () {
        var promptText = 'Which channel do you want to join?';
        var overlay = this.prompt(promptText, _.bind(function (channel) {
            this.connection.joinChannel(channel);
        }, this));
        overlay.className = 'connection_nick_prompt';
        this.triggerAdd(overlay);
    },
    ignorePrompt: function (user, callback) {
        var promptText = "Ignore messages from " + user.getNick() + ' at this hostmask:';
        var overlay = this.prompt(promptText, _.bind(function (mask) {
            this.connection.ignore(mask);
            if (callback) {
                callback();
            }
        }, this), user.getBanMask());
        overlay.className = 'connection_ignore_prompt';
        this.triggerAdd(overlay);
    },
    invitePrompt: function (user, callback) {
        var promptText = "Invite " + user.getNick() + " to a channel";
        var overlay = this.prompt(promptText, _.bind(function (channel) {
            user.invite(channel);
            if (callback) {
                callback();
            }
        }, this));
        overlay.className = 'connection_invite_prompt';
        this.triggerAdd(overlay);
    },
    genericConfirm: function (confirmText, callback, options) {
        var overlay = this.confirm(confirmText, _.bind(function () {
            if (callback) {
                callback();
            }
        }, this), options);
        overlay.className = options.overlayClass;
        this.triggerAdd(overlay);
    },
    deleteConfirm: function (callback) {
        var downloadLink = $('<a href="">').text('download').click(_.bind(function (e) {
            e.preventDefault();
            this.model.session.trigger('exportConfirm', this.connection);
        }, this));
        var confirmHtml = $('<div>');
        confirmHtml.append($('<p>').html("Are you sure you want to remove this connection and all its logs? Make sure you ").append(downloadLink).append(" any logs you want to keep before deleting."));
        var overlay = this.htmlConfirm(confirmHtml, _.bind(function () {
            this.connection.remove();
            if (callback) {
                callback();
            }
        }, this), {
            confirmClass: 'delete'
        });
        overlay.className = 'connection_delete_confirm';
        this.triggerAdd(overlay);
    },
    deletePMConfirm: function (callback) {
        var pms = this.connection.buffers.activeConversations;
        if (pms.length) {
            var s = pms.length > 1 ? 's' : '';
            var confirmHTML = $('<div>');
            confirmHTML.append($("<p>").text("You’ve chosen to delete " + pms.length + " private message" + s + ". Uncheck any you’d prefer to keep before continuing."));
            confirmHTML.append('<hr>');
            var list = $('<ul>');
            _.each(pms.sortBy('created'), function (pm, i) {
                var htmlId = 'b' + pm.id;
                var item = $('<li>');
                var badge = $('<span class="badge">');
                var label = $('<label>').attr('for', htmlId).text(pm.getName()).prepend(badge);
                if (pm.isTrackingUnread() && pm.hasUnseen()) {
                    label.addClass('unread');
                }
                if (pm.hasUnseenHighlights()) {
                    badge.text(pm.unseenHighlightCount());
                    label.addClass('activeBadge');
                }
                
                item
                    .append($('<input type="checkbox" checked>').attr({
                        'id': htmlId,
                        'name': 'bid',
                        'value': pm.id 
                    }))
                    .append(' ')
                    .append(label);
                list.append(item);
            }, this);
            confirmHTML.append(list);
            if (this.connection.hasUModeR()) {
                confirmHTML.append('<hr>');
                var commands = $('<a href="">').text('commands to run on connect').click(_.bind(function (e) {
                    e.preventDefault();
                    this.connection.select();
                    this.connection.trigger('showEdit', true, 'Commands');
                }, this));
                confirmHTML.append($('<p>').html("If you'd like to block messages from users who haven't identified with the IRC server, add <b><code>/umode +R</code></b> to your ").append(commands));
            }
            var overlay = this.htmlConfirm(confirmHTML, _.bind(function (formData, formDataArray) {
                _.each(formDataArray, function (data) {
                    if (data.name == 'bid') {
                        var pm = pms.get(data.value);
                        pm.remove();
                    }
                });
                if (callback) {
                    callback();
                }
            }, this), {
                confirmClass: 'delete',
                okText: 'Delete private messages'
            });
            overlay.className = 'connection_delete_pm_confirm';
            this.triggerAdd(overlay);
        }
    },
    messageHandlers: $.extend({}, BufferPromptHandler.prototype.messageHandlers, {
        // Prompt for input
        invalid_nick: function (message) {
            var promptText = this.formatter.render(message.msg);
            this.nickPrompt(promptText, message.invalid_nick);
        },
        no_such_channel: function (message) {
            var promptText = 'Invalid channel name on ' + this.connection.getFullLabel() + ', try again.';
            return this.prompt(promptText, _.bind(function (bufferName) {
                this.connection.openBuffer(bufferName);
            }, this), message.chan);
        },
        invalid_watch_nick: function (message) {
            return this.prompt(message.msg, _.bind(function (bufferName) {
                this.connection.serverLog.say('/watch +' + bufferName);
            }, this), message.nick, {
                okText: 'Watch'
            });
        },
        too_many_watch: function (message) {
            if (message.nick) {
                return this.alert(message.nick + ': ' + message.msg);
            } else {
                return this.alert(message.msg);
            }
        },
        no_such_nick: function (message) {
            var label = 'channel/nick';
            var okText = 'Open';
            switch (message.cmd_reply) {
            case 'whois':
                label = 'nick';
                okText = 'Whois';
                break;
            case 'names':
                label = 'channel';
                okText = '/names';
                break;
            }
            var promptText = 'No such ' + label + ' on ' + this.connection.getFullLabel() + ', try again.';
            return this.prompt(promptText, _.bind(function (bufferName) {
                switch (message.cmd_reply) {
                case 'whois':
                    this.connection.post('whois', {nick: bufferName});
                    break;
                case 'names':
                    this.connection.serverLog.say('/names ' + bufferName);
                    break;
                default:
                    this.connection.openBuffer(bufferName);
                    break;
                }
            }, this), message.nick, {
                okText: okText
            });
        },
        bad_channel_key: function (message) {
            var promptText = 'Password for ' + message.chan;
            return this.prompt(promptText, _.bind(function (key) {
                this.connection.joinChannel(message.chan, key);
            }, this));
        },
        bad_channel_name: function (message) {
            var promptText = 'Bad channel name: ' + message.chan + ', try again.';
            return this.prompt(promptText, _.bind(function (channel) {
                this.connection.joinChannel(channel);
            }, this), message.chan);
        },
        
        // Confirmation/alert
        need_registered_nick: function (message) {
            if (message.rfc2812) {
                // Conflict on IRCNet/2812 servers with ERR_NOCHANMODES
                return this.channelAlert(message);
            } else {
                var msg = this.formatter.linkChannel(message.chan) + ': ';
                msg += this.formatter.renderLinkify(message.msg);
                return this.htmlConfirm(msg, _.bind(function () {
                    this.connection.trigger('nickServPrompt', this.connection);
                }, this), {
                    okText: 'Identify with NickServ…',
                    extraContent: $('<p class="explanation">').text('Note: NickServ is not available on all networks')
                });
            }
        },
        blocked_channel: function (message) {
            return this.channelAlert(message, {
                msg: 'This channel is blocked by IRCCloud, you have been disconnected.'
            });
        },
        
        // Alerts
        invite_only_chan: function (message) {
            return this.channelAlert(message);
        },
        channel_full: function (message) {
            return this.channelAlert(message);
        },
        channel_key_set: function (message) {
            return this.channelAlert(message);  
        },
        banned_from_channel: function (message) {
            return this.channelAlert(message);
        },
        oper_only: function (message) {
            return this.alert(message.msg);
        },
        invalid_nick_change: function (message) {
            var msg = this.formatter.linkBuffer(message.ban_channel) +
                      ': ' + this.formatter.renderLinkify(message.msg);
            return this.htmlAlert(msg);
        },
        nickname_in_use: function (message) {
            return this.alert(message.nick + ': ' + message.msg);
        },
        no_nick_change: function (message) {
            return this.channelAlert(message);
        },
        no_messages_from_non_registered: function (message) {
            if (message.nick) {
                return this.alert(message.nick + ': ' + message.msg);
            } else {
                return this.alert(message.msg);
            }
        },
        not_registered: function (message) {
            var msg = message.first;
            if (message.rest) {
                msg += ' ' + message.rest;
            }
            return this.alert(msg + ': ' + message.msg);
        },
        already_registered: function (message) {
            return this.alert(message.msg);
        },
        too_many_channels: function (message) {
            return this.channelAlert(message);
        },
        too_many_targets: function (message) {
            return this.alert(message.description + ': ' + message.msg);
        },
        no_such_server: function (message) {
            return this.alert(message.server + ': ' + message.msg);
        },
        unknown_command: function (message) {
            var msg = message.msg || 'Unknown command';
            return this.htmlAlert('<b>' + this.formatter.escapeText(message.command) + '</b>: ' + this.formatter.escapeText(msg));
        },
        unknown_error: function (message) {
            return this.alert('Unknown error [' + message.command + '] ' + message.msg);
        },
        help_not_found: function (message) {
            return this.alert(message.topic + ': ' + message.msg);
        },
        accept_full: function (message) {
            return this.alert(message.msg);
        },
        accept_exists: function (message) {
            return this.alert(message.nick + ' ' + message.msg);
        },
        accept_not: function (message) {
            return this.alert(message.nick + ' ' + message.msg);
        },
        nick_collision: function (message) {
            return this.alert(message.collision + ': ' + message.msg);
        },
        nick_too_fast: function (message) {
            return this.alert(message.nick + ': ' + message.msg);
        },
        save_nick: function (message) {
            return this.alert(message.nick + ': ' + message.msg + ': ' + message.new_nick);
        },
        unknown_mode: function (message) {
            return this.alert('Missing mode: ' + message.param);
        },
        ban_list_full: function (message) {
            var prefix;
            if (message.ban) {
                prefix = '<b>' + this.formatter.render(message.ban) + '</b> ';
            }
            return this.channelAlert(message, {
                prefix: prefix
            });
        },
        user_not_in_channel: function (message) {
            return this.alert(message.nick + ' is not in ' + message.channel);
        },
        need_more_params: function (message) {
            return this.alert('Missing parameters for command: ' + message.command);
        },
        users_dont_match: function (message) {
            return this.alert(message.msg);
        },
        cannot_set_mode_r: function (message) {
            return this.alert(message.msg);
        },
        chan_privs_needed: function (message) {
            return this.channelAlert(message);
        },
        chan_own_priv_needed: function (message) {
            return this.channelAlert(message);
        },
        unknown_umode: function (message) {
            var msg = this.formatter.render(message.msg);
            if (message.flag) {
                msg = '<b>' + this.formatter.render(message.flag) + '</b> ' + msg;
            }
            return this.htmlAlert(msg);
        },

        users_disabled: function (message) {
            return this.alert(message.msg);
        },
        invalid_operator_password: function (message) {
            return this.alert(message.msg);
        },
        flood_warning: function (message) {
            return this.alert(message.msg);
        },
        privs_needed: function (message) {
            return this.alert(message.msg);
        },
        operator_fail: function (message) {
            return this.alert(message.msg);
        },
        not_on_channel: function (message) {
            return this.channelAlert(message);
        },
        ban_on_chan: function (message) {
            return this.htmlAlert(
                this.formatter.linkChannel(message.channel) +
                ': nick change prevented<br>' +
                this.formatter.escapeText(this.connection.getNick()) +
                ' → ' +
                this.formatter.escapeText(message.proposed_nick) +
                '<br>' +
                this.formatter.renderLinkify(message.msg)
            );
        },
        cannot_send_to_chan: function (message) {
            return this.channelAlert(message);
        },
        cant_send_to_user: function (message) {
            return this.alert(message.nick + ': ' + message.msg);
        },
        user_on_channel: function (message) {
            return this.htmlAlert(this.formatter.linkBuffer(message.nick) + ' is already a member of ' + this.formatter.linkChannel(message.channel));
        },
        pong: function (message) {
            var overlay;
            if (message.origin) {
                overlay = this.alert('PONG from ' + message.origin + ': ' + message.msg);
            } else {
                overlay = this.alert('PONG: ' + message.msg);
            }
            overlay.keepFocus = true;
            return overlay;
        },
        no_nick_given: function (message) {
            return this.alert('No nickname given');
        },
        no_text_to_send: function (message) {
            return this.alert(message.msg);
        },
        no_origin: function (message) {
            return this.alert(message.msg);
        },
        only_servers_can_change_mode: function (message) {
            return this.alert(message.msg);
        },
        not_for_halfops: function (message) {
            return this.alert(message.msg);
        },
        // unreal/ircu/inspircd 3+
        silence: function (message) {
            var mask = message.usermask;
            var msg;
            if (message.usermask.indexOf('-') === 0) {
                msg = mask.substr(1) + ' removed from silence list';
            } else if (mask.indexOf('+') === 0) {
                msg = mask.substr(1) + ' added to silence list';
            } else {
                msg = 'Silence list change: ' + mask;
            }
            return this.alert(msg);
        },
        // inspircd 2.0
        unsilenced: function (message) {
            return this.alert(message.msg);
        },
        silenced: function (message) {
            return this.alert(message.msg);
        },
        not_silenced: function (message) {
            return this.alert(message.msg);
        },
        monitor_full: function (message) {
            var msg = '<b>' + this.formatter.escapeText(message.targets) + '</b>: ' + this.formatter.render(message.msg);
            if (_.isNumber(message.limit)) {
                msg += ' (limit: ' + message.limit + ')';
            }
            return this.htmlAlert(msg);
        },
        no_channel_topic: function (message) {
            return this.channelAlert(message);
        },
        channel_topic_is: function (message) {
            var msg = '<p class="explanation">';
            if (message.author) {
                var author = this.connection.makeUserFromTarget(
                    null,
                    _.extend({}, message, {
                        nick: message.author
                    })
                );
                msg += "Set by " + this.formatter.linkUser(author);
            } else {
                msg += 'Set';
            }
            msg += " on " + new Date(message.time * 1000).formatFullDate();
            msg += '</p>';
            msg += '<p>' + this.formatter.renderLinkifyComicSans(message.text) + '</p>';
            return this.htmlAlert(msg, {
                head: 'Topic for ' + this.formatter.linkChannel(message.chan) + ' (' + this.formatter.linkModel(this.connection) + ')'
            });
        },
        mlock_restricted: function (message) {
            var msg = '<p>' + this.formatter.linkChannel(message.channel) + ': ' + this.formatter.render(message.msg) + '</p>';
            msg += '<p>MLOCK: <b>' + this.formatter.render(message.mlock) + '</b></p>';
            msg += '<p>Requested mode change: <b>' + this.formatter.render(message.mode_change) + '</b></p>';
            return this.htmlAlert(msg);
        },
        cannot_do_cmd: function (message) {
            var msg = '';
            if (message.cmd) {
                msg += message.cmd + ': ';
            }
            msg += message.msg;
            return this.alert(msg);
        },
        secure_only_chan: function (message) {
            return this.channelAlert(message);
        },
        cannot_change_chan_mode: function (message) {
            var msg = "You can't change channel mode";
            if (message.mode) {
                msg += ': <b>' + this.formatter.render(message.mode) + '</b>';
            }
            msg += '; ' + this.formatter.render(message.msg);
            return this.htmlAlert(msg);
        },
        knock_delivered: function (message) {
            return this.channelAlert(message);
        },
        too_many_knocks: function (message) {
            return this.channelAlert(message);
        },
        chan_open: function (message) {
            return this.channelAlert(message);
        },
        knock_on_chan: function (message) {
            return this.channelAlert(message);
        },
        knock_disabled: function (message) {
            return this.channelAlert(message);
        },
        cannotknock: function (message) {
            return this.channelAlert(message);
        },
        ownmode: function (message) {
            return this.alert(message.msg);
        },
        nossl: function (message) {
            return this.channelAlert(message);
        },
        link_channel: function (message) {
            if (!message.valid_channel || message.valid_channel == '*') {
                var prefix = '';
                if (message.invalid_chan) {
                    prefix = this.formatter.linkChannel(message.invalid_chan) + ' ';
                }
                return this.htmlAlert(prefix + this.formatter.renderLinkify(message.msg));
            }
        },
        redirect_error: function (message) {
            return this.alert(message.msg);
        },
        invalid_flood: function (message) {
            return this.channelAlert(message);
        },
        join_flood: function (message) {
            return this.channelAlert(message);
        },
        err_restricted: function (message) {
            if (message.channel) {
                var options = {};
                if (message.target) {
                    options.prefix = '(' + this.formatter.linkBuffer(message.target) + ') ';
                }
                return this.channelAlert(message, options);
            } else {
                return this.alert(message.msg);
            }
        },
        list_syntax: function (message) {
            return this.alert(message.msg);
        },
        who_syntax: function (message) {
            return this.alert(message.msg);
        },

        metadata_limit: function (message) {
            var msg = this.formatter.render(message.msg) + ': <b>' + this.formatter.escapeText(message.target) + '</b>';
            return this.htmlAlert(msg);
        },
        metadata_targetinvalid: function (message) {
            var msg = this.formatter.render(message.msg) + ': <b>' + this.formatter.escapeText(message.target) + '</b>';
            return this.htmlAlert(msg);
        },
        metadata_nomatchingkey: function (message) {
            var msg = this.formatter.render(message.msg) + ': <b>' + this.formatter.escapeText(message.key) + '</b> for target: <b>' + this.formatter.escapeText(message.target) + '</b>';
            return this.htmlAlert(msg);
        },
        metadata_keyinvalid: function (message) {
            var msg = 'Invalid metadata key: <b>' + this.formatter.escapeText(message.key) + '</b>';
            return this.htmlAlert(msg);
        },
        metadata_keynotset: function (message) {
            var msg = this.formatter.render(message.msg) + ': <b>' + this.formatter.escapeText(message.key) + '</b> for target: <b>' + this.formatter.escapeText(message.target) + '</b>';
            return this.htmlAlert(msg);
        },
        metadata_keynopermission: function (message) {
            var msg = this.formatter.render(message.msg) + ': <b>' + this.formatter.escapeText(message.key) + '</b> for target: <b>' + this.formatter.escapeText(message.target) + '</b>';
            return this.htmlAlert(msg);
        },
        metadata_toomanysubs: function (message) {
            var msg = 'Metadata key subscription limit reached, keys after and including <b>' + this.formatter.escapeText(message.key) + '</b> not subscribed';
            return this.htmlAlert(msg);
        },
        fail: function (message) {
            return this.standardReply('FAIL', message);
        },
        warn: function (message) {
            return this.standardReply('WARN', message);
        },
        note: function (message) {
            return this.standardReply('NOTE', message);
        }
    })
});


module.exports = ConnectionPromptHandler;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/connectionprompthandler.js
// module id = 2rjW
// module chunks = 1